/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {navigationHeaderHeight} from '../base/drawer'

export default {
    baseStyle: ({theme}) => ({
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            minWidth: '375px',
            // this is the hardcoded values from header.js (height)
            paddingTop: {
                base: '4.375rem',
                lg: '6.875rem'
            }
        },
        headerWrapper: {
            position: 'fixed',
            top: 0,
            width: 'full',
            zIndex: theme.zIndices.sticky
        }
    }),
    variants: {
        messageBar: {
            container: {
                paddingTop: {
                    base: `calc(${navigationHeaderHeight.messageBar.base} + var(--pdp-subnavigation-height, 0px))`,
                    lg: `calc(${navigationHeaderHeight.messageBar.lg} + var(--pdp-subnavigation-height, 0px))`,
                    xl: `calc(${navigationHeaderHeight.messageBar.xl} + var(--pdp-subnavigation-height, 0px))`
                }
            }
        }
    },
    parts: ['container', 'headerWrapper']
}
